var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"om-page",class:_vm.classes},[_c('common-notifications'),(_vm.title)?_c('h1',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default",[_c('p',[_vm._v("Page content goes here...")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }